import { MainTemplates } from "../../components/template/MainTemplates";
import { MorePageContent } from "../../components/organisms/MorePageContent";
import { GET_USER_TRANSPORT } from "../../common/query-keys";
import { useQuery } from "@tanstack/react-query";
import { request } from "../../lib/api";
const MorePage = (props: any) => {
  /** 운송, 배차, 요금에 대한 정보 GET */
  const { data: userTransportData } = useQuery({
    queryKey: [GET_USER_TRANSPORT],
    queryFn: async () => {
      const result = await request<any>({
        method: "GET",
        url: GET_USER_TRANSPORT,
      });

      return result;
    },
  });
  return (
    <MainTemplates pageTitle="더보기">
      <MorePageContent userTransportData={userTransportData} />
    </MainTemplates>
  );
};

export default MorePage;
